import type { RegistroBase, RegraComissao, TabelaPreco } from '../db/tipos'
import { normalizarTexto } from '../lib/textoBR'
import { converterComissao } from '../importacao/validacao'
import { MSG_COMISSAO, type GravacaoDaTabela } from './rascunhoDaTabela'

// "+ Tabela" > "Criar do zero" (spec 2026-09-29, secao 4). O nome e checado
// aqui, e nao so no servidor: ha indice unico (representada_id,
// nome_normalizado) desde a 0009, e a recusa la so apareceria depois, na fila.
export const MSG_NOME_VAZIO = 'Informe o nome da tabela.'
export const MSG_NOME_REPETIDO = 'Já existe uma tabela com esse nome.'
type Novo = () => Pick<RegistroBase, 'id' | 'criado_em' | 'atualizado_em' | 'apagado_em'>

export function gravacoesDeTabelaNova(e: {
  representadaId: string; nome: string; pct: string; tabelasVivas: TabelaPreco[]
  regraDaFornecedora: RegraComissao | undefined; novo: Novo
}): { erroNome?: string; erroPct?: string } | { tabelaId: string; gravacoes: GravacaoDaTabela[] } {
  const nome = e.nome.trim()
  const norm = normalizarTexto(nome)
  const pct = converterComissao(e.pct)
  const erroNome = nome === '' ? MSG_NOME_VAZIO
    : e.tabelasVivas.some((t) => t.apagado_em === null && (t.nome_normalizado ?? normalizarTexto(t.nome)) === norm) ? MSG_NOME_REPETIDO
    : undefined
  const erroPct = pct === null ? MSG_COMISSAO : undefined
  if (erroNome || erroPct) return { ...(erroNome ? { erroNome } : {}), ...(erroPct ? { erroPct } : {}) }
  const tabela: TabelaPreco = {
    ...e.novo(), representada_id: e.representadaId, nome, nome_normalizado: norm,
    vigencia_inicio: null, vigencia_fim: null, ativa: true, condicoes_validas: [],
  }
  const regra: RegraComissao = {
    ...e.novo(), representada_id: e.representadaId, tabela_preco_id: tabela.id, tipo: 'pct_fixo', pct_padrao: pct,
    gatilho_liberacao: e.regraDaFornecedora?.gatilho_liberacao ?? 'faturamento',
  }
  return { tabelaId: tabela.id, gravacoes: [{ tabela: 'tabelas_preco', registro: tabela }, { tabela: 'regras_comissao', registro: regra }] }
}

// "+ Nova tabela…" dentro do cadastro de produto (pedido dela 30/09, opcao A):
// so o NOME; a comissao e a padrao da fornecedora, copiada numa regra propria
// da tabela -- o mesmo caminho do "Criar do zero", sem pedir o %.
export const MSG_SEM_COMISSAO_PADRAO =
  'Esta fornecedora não tem comissão padrão. Crie a tabela em Fornecedoras > Política Comercial.'

export function gravacoesDeTabelaSoNome(e: {
  representadaId: string; nome: string; tabelasVivas: TabelaPreco[]
  regraDaFornecedora: RegraComissao | undefined; novo: Novo
}): { erroNome?: string; erroPct?: string } | { tabelaId: string; gravacoes: GravacaoDaTabela[] } {
  const pct = e.regraDaFornecedora?.pct_padrao
  if (pct == null) return { erroNome: MSG_SEM_COMISSAO_PADRAO }
  return gravacoesDeTabelaNova({ ...e, pct: String(pct).replace('.', ',') })
}
